import ItemBreakpoint from 'Custom/ItemBreakpoint';
import Link from 'node_modules/next/link';
import styles from 'styles/pages/sideEffects.module.scss';

const OTHER_PROBLEMS_LIST = [
  'Dolor, irritación, hinchazón o formación de hematomas en el lugar de la inserción',
  'Entumecimiento y hormigueo en el lugar de la inserción',
  'Formación de cicatrices, incluida una cicatriz gruesa llamada queloide alrededor del lugar de la inserción',
  'Infección',
  'Puede formarse tejido cicatricial alrededor del implante que podría dificultar la extracción',
  'El implante puede salirse solo. Puede quedar embarazada si el implante se sale solo. Use un método anticonceptivo de respaldo y llame a su profesional de la salud de inmediato si el implante se sale',
  'La necesidad de realizar una cirugía en el hospital para extraer el implante',
  'Daño en los nervios o vasos sanguíneos del brazo',
  'El implante se rompe y se hace difícil su extracción',
];

const BLOOD_CONDITIONS_LIST = [
  'Las piernas (trombosis venosa profunda)',
  'Los pulmones (embolia pulmonar)',
  'El cerebro (accidente cerebrovascular)',
  'El corazón (infarto de miocardio)',
  'Los ojos (ceguera total o parcial)',
];

const OTHER_RISKS_LIST = [
  'Presión arterial alta',
  'Problemas en la vesícula biliar',
  'Tumores del hígado cancerosos o no cancerosos raros',
];

const MENSTRUL_PERIODS_LIST = [
  'Sangrado más prolongado o más breve durante el período',
  'Ausencia total de sangrado durante el término de su período',
  'Manchado entre períodos',
  'Lapsos de tiempo diversos entre sus períodos',
];

export const SE_LIST_1 = [
  'Cambios del estado de ánimo',
  'Aumento de peso',
  'Estado depresivo',
  'Acné',
  'Dolor de cabeza',
];

export const SE_LIST_2 = [
  'Dolor de cabeza',
  'Vaginitis (inflamación de la vagina)',
  'Aumento de peso',
  'Acné',
  'Dolor en los senos',
  'Infecciones virales, como dolor de garganta o síntomas semejantes a la gripe',
  'Dolor de estómago',
  'Períodos menstruales dolorosos',
  'Cambios del estado de ánimo, nerviosismo o estado depresivo',
  'Dolor de espalda',
  'Náuseas',
  'Mareos',
  'Dolor',
  'Dolor en el lugar de la inserción',
];

export const SE_TABLE_1 = [
  {
    title:
      'Cambios en los patrones de sangrado menstrual (períodos menstruales)',
    body: (
      <>
        <p>
          En estudios, 1 de cada 10 mujeres dejó de usar NEXPLANON por un cambio
          desfavorable en su patrón de sangrado. Usted puede presentar los
          siguientes síntomas:
        </p>
        {MENSTRUL_PERIODS_LIST && (
          <ul>
            {MENSTRUL_PERIODS_LIST.map((item, i) => (
              <li key={`faq-se-mp-single${i}`}>{item}</li>
            ))}
          </ul>
        )}
        <p>
          Informe de inmediato a su médico si cree que puede estar embarazada o
          el sangrado menstrual es abundante y prolongado.
        </p>
      </>
    ),
  },
  {
    title:
      'Entre los demás efectos secundarios frecuentes por los cuales las mujeres dejan de usar NEXPLANON, se incluyen los siguientes:',
    body: (
      <ItemBreakpoint>
        <>
          {SE_LIST_1 && (
            <div className={`${styles.splittedList} ${styles.noMargin}`}>
              <ul>
                {SE_LIST_1.slice(0, 3).map((item, i) => (
                  <li key={`faq-wte-se1-1${i}`}>{item}</li>
                ))}
              </ul>
              <ul>
                {SE_LIST_1.slice(3, 5).map((item, i) => (
                  <li key={`faq-wte-se1-2-${i}`}>{item}</li>
                ))}
              </ul>
            </div>
          )}
        </>
        <div className={styles.mobileList}>
          {SE_LIST_1 && (
            <ul>
              {SE_LIST_1.map((item, i) => (
                <li key={`faq-wte-se1-single${i}`}>{item}</li>
              ))}
            </ul>
          )}
        </div>
      </ItemBreakpoint>
    ),
  },
  {
    title: 'Otros efectos secundarios comunes de NEXPLANON:',
    body: (
      <>
        <ItemBreakpoint>
          <>
            {SE_LIST_2 && (
              <div className={`${styles.splittedList} ${styles.noMargin}`}>
                <ul>
                  {SE_LIST_2.slice(0, 7).map((item, i) => (
                    <li key={`faq-wte-se-1-${i}`}>{item}</li>
                  ))}
                </ul>
                <ul>
                  {SE_LIST_2.slice(7, 15).map((item, i) => (
                    <li key={`faq-wte-se-2-${i}`}>{item}</li>
                  ))}
                </ul>
              </div>
            )}
          </>
          <div className={styles.mobileList}>
            {SE_LIST_2 && (
              <ul>
                {SE_LIST_2.map((item, i) => (
                  <li key={`faq-wte-se-single-${i}`}>{item}</li>
                ))}
              </ul>
            )}
          </div>
        </ItemBreakpoint>
        <p className={styles.mt}>
          Se han informado casos de implantes que se han encontrado en los vasos
          sanguíneos, incluidos los vasos sanguíneos del pulmón.
        </p>
        <p>
          Esta no es una lista completa de los posibles efectos secundarios.
          Para obtener más información, pida a su profesional de la salud que la
          aconseje sobre los efectos secundarios que le preocupan. Puede
          informar a la FDA (Administración de Alimentos y Medicamentos) acerca
          de los efectos secundarios llamando al{' '}
          <Link
            data-design-category="content_link_vd"
            className={styles.phoneLink}
            href="tel:18003321088"
          >
            1-800-FDA-1088
          </Link>
          .
        </p>
      </>
    ),
  },
];

export const CONDITIONS_TABLE = {
  content: [
    'TIENE DIABETES',
    'TIENE COLESTEROL ELEVADO',
    'TIENE TRIGLICÉRIDOS ELEVADOS',
    'TIENE DOLOR DE CABEZA',
    'TIENE PROBLEMAS DE LA VESÍCULA BILIAR',
    'TIENE PROBLEMAS DE LOS RIÑONES',
    'TIENE ANTECEDENTES DE ESTADO DEPRESIVO',
    'TIENE PRESIÓN ARTERIAL ALTA',
  ],
};

export const SE_TABLE_2 = [
  {
    title: 'problemas con la inserción y la extracción',
    body: (
      <>
        <p>
          Es posible que el implante no esté realmente en el brazo debido a una
          colocación fallida. Si esto sucede, podría quedar embarazada.
        </p>
        <p>
          Inmediatamente después de la inserción y con la ayuda del profesional
          de la salud, usted debería poder palpar el implante debajo de la piel.
          Si no puede hacerlo, informe a su profesional de la salud.
        </p>
      </>
    ),
  },
  {
    title: 'la localización y extracción del implante podría ser muy difícil',
    body: (
      <>
        <p>
          La localización y extracción del implante podría ser muy difícil o
          imposible si el implante no está donde debería estar. Es posible que
          sean necesarios procedimientos especiales, incluida una cirugía en el
          hospital, para extraer el implante. Si no se extrae el implante, los
          efectos de NEXPLANON se prolongarán por más tiempo.
        </p>
        <p>
          Se han encontrado implantes en la arteria pulmonar (un vaso sanguíneo
          del pulmón). Si el implante no puede encontrarse en el brazo, es
          posible que el profesional de la salud le tome una radiografía del
          tórax o use otro método de diagnóstico por imágenes. Si el implante se
          encuentra en el pecho, es posible que se requiera una cirugía.
        </p>
      </>
    ),
  },
  {
    title: 'otros problemas relacionados con la inserción y la extracción',
    body: (
      <ItemBreakpoint>
        <>
          {OTHER_PROBLEMS_LIST && (
            <div className={`${styles.splittedList} ${styles.noMargin}`}>
              <ul>
                {OTHER_PROBLEMS_LIST.slice(0, 5).map((item, i) => (
                  <li key={`faq-se-op-1${i}`}>{item}</li>
                ))}
              </ul>
              <ul>
                {OTHER_PROBLEMS_LIST.slice(5, 10).map((item, i) => (
                  <li key={`faq-se-op-2-${i}`}>{item}</li>
                ))}
              </ul>
            </div>
          )}
        </>
        <div className={styles.mobileList}>
          {OTHER_PROBLEMS_LIST && (
            <ul>
              {OTHER_PROBLEMS_LIST.map((item, i) => (
                <li key={`faq-se-op-single${i}`}>{item}</li>
              ))}
            </ul>
          )}
        </div>
      </ItemBreakpoint>
    ),
  },
  {
    title: 'embarazo ectópico',
    body: (
      <>
        <p>
          Si queda embarazada mientras utiliza NEXPLANON, tiene una probabilidad
          un poco más alta de que el embarazo sea ectópico (fuera del útero) que
          las mujeres que no utilizan métodos anticonceptivos.
        </p>
        <p>
          El sangrado vaginal fuera de lo común o el dolor en la parte inferior
          del estómago (abdominal) pueden ser signos de un embarazo ectópico.
        </p>
        <p>
          El embarazo ectópico es una emergencia médica que a menudo requiere
          cirugía.
        </p>
        <p>
          Los embarazos ectópicos pueden provocar sangrado interno grave,
          infertilidad e incluso la muerte. Llame de inmediato a su profesional
          de la salud si cree que está embarazada o tiene un dolor en la parte
          inferior del estómago (abdominal) sin motivo aparente.
        </p>
      </>
    ),
  },
  {
    title: 'quistes de ovario y cáncer de mama',
    body: (
      <>
        <p>
          Es posible que se formen quistes en los ovarios que a menudo
          desaparecen sin tratamiento, pero a veces es necesario recurrir a la
          cirugía para extirparlos.
        </p>
        <p>
          Se desconoce si el uso de NEXPLANON cambia el riesgo de padecer cáncer
          de seno de una mujer. Si actualmente tiene cáncer de mama, o tuvo en
          el pasado, no use NEXPLANON, ya que algunos tipos de cáncer de mama
          son sensibles a las hormonas.
        </p>
      </>
    ),
  },
  {
    title: 'coágulos de sangre graves',
    body: (
      <>
        <p>
          NEXPLANON puede aumentar la probabilidad de que aparezcan coágulos de
          sangre graves, especialmente si hay otros factores de riesgo, como el
          hábito de fumar. Es posible morir por un problema provocado por un
          coágulo de sangre, como un ataque cardíaco o un accidente
          cerebrovascular.
        </p>
        <p>
          Algunos ejemplos de coágulos de sangre graves son coágulos de sangre
          en:
        </p>
        <ItemBreakpoint>
          <>
            {BLOOD_CONDITIONS_LIST && (
              <div className={styles.splittedList}>
                <ul>
                  {BLOOD_CONDITIONS_LIST.slice(0, 3).map((item, i) => (
                    <li key={`faq-bc-op-1${i}`}>{item}</li>
                  ))}
                </ul>
                <ul>
                  {BLOOD_CONDITIONS_LIST.slice(3, 5).map((item, i) => (
                    <li key={`faq-bc-op-2-${i}`}>{item}</li>
                  ))}
                </ul>
              </div>
            )}
          </>
          {BLOOD_CONDITIONS_LIST && (
            <div className={styles.mobileList}>
              <ul>
                {BLOOD_CONDITIONS_LIST.map((item, i) => (
                  <li key={`faq-bc-op-21${i}`}>{item}</li>
                ))}
              </ul>
            </div>
          )}
        </ItemBreakpoint>
        <p>
          Las mujeres que fuman tienen mayor riesgo de tener coágulos de sangre
          graves. Si fuma y desea utilizar NEXPLANON, debe dejar de fumar. Su
          profesional de la salud puede ayudarla.
        </p>
        <p>
          Informe al profesional de la salud, al menos 4 semanas antes, si va a
          someterse a una cirugía o si necesitará hacer reposo en cama, dado que
          tiene mayores probabilidades de sufrir coágulos de sangre durante la
          cirugía o el reposo en cama.
        </p>
      </>
    ),
  },
  {
    title: 'otros riesgos',
    body: (
      <>
        <p>
          Es posible que algunas mujeres que utilizan métodos anticonceptivos
          que contienen hormonas presenten:
        </p>
        {OTHER_RISKS_LIST && (
          <ul>
            {OTHER_RISKS_LIST.map((item, i) => (
              <li key={`faq-se-op-single${i}`}>{item}</li>
            ))}
          </ul>
        )}
        <p>
          Si piensa que existe la posibilidad de que el implante se haya roto o
          se haya doblado, por favor comuníquese con su médico.
        </p>
      </>
    ),
  },
];

export const SE_TABLE_3 = [
  {
    title: 'dolor en la parte inferior de la pierna',
    body: 'que no cesa',
  },
  {
    title: 'dolor de pecho intenso',
    body: 'u opresión en el pecho',
  },
  {
    title: 'dificultad repentina para respirar',
    body: 'fuerte dolor en el pecho o tos con sangre',
  },
  {
    title: 'síntomas de una reacción alérgica grave',
    body: 'como hinchazón de la cara, la lengua o la garganta; dificultad para tragar o para respirar',
  },
  {
    title: 'dolores de cabeza intensos y repentinos',
    body: 'distintos de los dolores de cabeza habituales',
  },
  {
    title: 'debilidad o adormecimiento',
    body: 'en el brazo o la pierna, o dificultad para hablar',
  },
  {
    title: 'ceguera repentina',
    body: 'parcial o total',
  },
  {
    title: 'color amarillento de la piel o la parte blanca de los ojos',
    body: 'especialmente acompañado de fiebre, cansancio, pérdida del apetito, orina de color oscuro o heces de color claro',
  },
  {
    title: 'dolor intenso o hinchazón',
    body: 'cualquier sensación dolorosa, hinchazón, o sensibilidad en la parte inferior del estómago (abdomen)',
  },
  {
    title: 'bulto en el seno',
    body: 'deberías revisarte regularmente',
  },
  {
    title: 'problemas para dormir',
    body: 'falta de energía, cansancio o mucha tristeza',
  },
  {
    title: 'sangrado menstrual abundante',
    body: 'más abundante de lo normal',
  },
  {
    title: 'sensación de que el implante puede haberse roto o doblado',
    body: 'mientras se encontraba en el brazo por causa de un accidente',
  },
];

export const WARNINGS_ITEMS_LIST = [
  'Está embarazada o cree que podría estarlo',
  'Tiene o tuvo coágulos de sangre, como coágulos de sangre en las piernas (trombosis venosa profunda), los pulmones (embolia pulmonar), los ojos (ceguera total o parcial), el corazón (infarto de miocardio) o el cerebro (accidente cerebrovascular)',
  'Tiene una enfermedad hepática o un tumor hepático',
  'Tiene sangrado vaginal sin motivo aparente',
  'Tiene o tuvo cáncer de mama u otro tipo de cáncer sensible a la progestina (una hormona femenina)',
  'Es alérgica a algún componente de NEXPLANON',
];

export const WARNINGS_TITLE = 'no utilice NEXPLANON si:';
